"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
require("core-js/modules/esnext.global-this.js");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var global = typeof globalThis !== "undefined" ? globalThis : window;
var turnstileState = typeof global.turnstile !== "undefined" ? "ready" : "unloaded";
var ensureTurnstile;
// Functions responsible for loading the turnstile api, while also making sure
// to only load it once
{
  var TURNSTILE_LOAD_FUNCTION = "cf__reactTurnstileOnLoad";
  var TURNSTILE_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js";
  var turnstileLoad;
  var turnstileLoadPromise = new Promise(function (resolve, reject) {
    turnstileLoad = {
      resolve: resolve,
      reject: reject
    };
    if (turnstileState === "ready") resolve(undefined);
  });
  ensureTurnstile = function ensureTurnstile() {
    if (turnstileState === "unloaded") {
      turnstileState = "loading";
      global[TURNSTILE_LOAD_FUNCTION] = function () {
        turnstileLoad.resolve();
        turnstileState = "ready";
        delete global[TURNSTILE_LOAD_FUNCTION];
      };
      var url = "".concat(TURNSTILE_SRC, "?onload=").concat(TURNSTILE_LOAD_FUNCTION, "&render=explicit");
      var script = document.createElement("script");
      script.src = url;
      script.async = true;
      script.addEventListener("error", function () {
        turnstileLoad.reject("Failed to load Turnstile.");
        delete global[TURNSTILE_LOAD_FUNCTION];
      });
      document.head.appendChild(script);
    }
    return turnstileLoadPromise;
  };
}
function Turnstile(_ref) {
  var id = _ref.id,
    className = _ref.className,
    style = _ref.style,
    sitekey = _ref.sitekey,
    action = _ref.action,
    cData = _ref.cData,
    theme = _ref.theme,
    language = _ref.language,
    tabIndex = _ref.tabIndex,
    responseField = _ref.responseField,
    responseFieldName = _ref.responseFieldName,
    size = _ref.size,
    retry = _ref.retry,
    retryInterval = _ref.retryInterval,
    refreshExpired = _ref.refreshExpired,
    appearance = _ref.appearance,
    execution = _ref.execution,
    userRef = _ref.userRef,
    onVerify = _ref.onVerify,
    onLoad = _ref.onLoad,
    onError = _ref.onError,
    onExpire = _ref.onExpire,
    onTimeout = _ref.onTimeout;
  var ownRef = (0, react_1.useRef)(null);
  var inplaceState = (0, react_1.useState)({
    onVerify: onVerify
  })[0];
  var ref = userRef !== null && userRef !== void 0 ? userRef : ownRef;
  (0, react_1.useEffect)(function () {
    if (!ref.current) return;
    var cancelled = false;
    var widgetId = "";
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _a, _b, turnstileOptions;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(turnstileState !== "ready")) {
              _context.next = 10;
              break;
            }
            _context.prev = 1;
            _context.next = 4;
            return ensureTurnstile();
          case 4:
            _context.next = 10;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](1);
            (_a = inplaceState.onError) === null || _a === void 0 ? void 0 : _a.call(inplaceState, _context.t0);
            return _context.abrupt("return");
          case 10:
            if (!(cancelled || !ref.current)) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return");
          case 12:
            turnstileOptions = {
              sitekey: sitekey,
              action: action,
              cData: cData,
              theme: theme,
              language: language,
              tabindex: tabIndex,
              "response-field": responseField,
              "response-field-name": responseFieldName,
              size: size,
              retry: retry,
              "retry-interval": retryInterval,
              "refresh-expired": refreshExpired,
              appearance: appearance,
              execution: execution,
              callback: function callback(token) {
                return inplaceState.onVerify(token);
              },
              "error-callback": function errorCallback() {
                var _a;
                return (_a = inplaceState.onError) === null || _a === void 0 ? void 0 : _a.call(inplaceState);
              },
              "expired-callback": function expiredCallback() {
                var _a;
                return (_a = inplaceState.onExpire) === null || _a === void 0 ? void 0 : _a.call(inplaceState);
              },
              "timeout-callback": function timeoutCallback() {
                var _a;
                return (_a = inplaceState.onTimeout) === null || _a === void 0 ? void 0 : _a.call(inplaceState);
              }
            };
            widgetId = window.turnstile.render(ref.current, turnstileOptions);
            (_b = inplaceState.onLoad) === null || _b === void 0 ? void 0 : _b.call(inplaceState, widgetId);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 6]]);
    }))();
    return function () {
      cancelled = true;
      if (widgetId) window.turnstile.remove(widgetId);
    };
  }, [sitekey, action, cData, theme, language, tabIndex, responseField, responseFieldName, size, retry, retryInterval, refreshExpired, appearance, execution]);
  (0, react_1.useEffect)(function () {
    inplaceState.onVerify = onVerify;
    inplaceState.onLoad = onLoad;
    inplaceState.onError = onError;
    inplaceState.onExpire = onExpire;
    inplaceState.onTimeout = onTimeout;
  }, [onVerify, onLoad, onError, onExpire, onTimeout]);
  return react_1.default.createElement("div", {
    ref: ref,
    id: id,
    className: className,
    style: style
  });
}
exports.default = Turnstile;